import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isZerodhaConnected: false
};

const zerodhaSlice = createSlice({
  name: 'zerodha',
  initialState,
  reducers: {
    setZerodhaStatus(state, action) {
      state.isZerodhaConnected = action.payload;
    },
  }
});

export const { setZerodhaStatus } = zerodhaSlice.actions;
export const selectZerodhaStatus = (state: any) => state.zerodha.isZerodhaConnected;
export default zerodhaSlice.reducer;
